export const TRUCK_SHOP = "truck-shop";
export const ROAD_ASSISTANCE = "road-assistance";
export const TOWING = "towing";
export const TIRE_REPAIR = "tire-repair";
export const TRAILER_REPAIR = "trailer-repair";
export const TIRE_SHOP = "tire-shop";
